import { SelectItem } from 'platform/common/common.type';

export const makeOptions = <T extends string>(labels: { [key in T]: string }): SelectItem<T>[] =>
    Object.keys(labels).map((key: T) => ({
        value: key,
        label: labels[key],
    }));
